import { combineReducers } from "redux";

import Cart from './cart/reducers'
import reducerOrder from './orders/reducers'

export const rootReducer = combineReducers({
    Cart,
    reducerOrder
});
